// src/ui/boot-watchdog.js — red de seguridad global del arranque.
//
// Auditoría "app tildada" (5-jun-2026): aunque los awaits de auth/grupos ya
// tienen timeout, si CUALQUIER cosa deja el boot atascado, la card de carga
// "#app-loading-card" (en index.html) quedaría visible para siempre. Este
// watchdog la detecta tras BOOT_WATCHDOG_MS y la reemplaza por una pantalla de
// "Reintentar" en vez de "Cargando aplicación…" eterno. Se cancela solo: si el
// primer render ya corrió, #app-loading-card no existe y no hace nada.

import { purgeSupabaseAuthStorage } from '../utils/supabase-storage.js'
import { hideLoadingOverlay } from './loading-overlay.js'

export const BOOT_WATCHDOG_MS = 14000

// Pinta la pantalla de error de boot en `root`. Exportada para test. El botón
// lleva data-boot-retry (no onclick inline) — el wiring lo hace scheduleBootWatchdog
// para poder PURGAR el estado de auth corrupto ANTES de recargar.
export const renderBootError = (root) => {
  root.innerHTML = `
        <div class="glass-card view-enter" style="text-align:center;">
            <h1 style="font-family:var(--font-heading);font-size:1.45rem;color:var(--white);margin-bottom:.45rem;">No se pudo cargar</h1>
            <p style="color:var(--text-muted);font-size:.9rem;line-height:1.4;margin-bottom:1rem;">La app tardó demasiado en responder. Probá de nuevo.</p>
            <button class="btn btn-primary" type="button" style="min-height:46px;" data-boot-retry>Reintentar</button>
        </div>`
}

// Recarga LIMPIA: purga las claves sb-* de Supabase ANTES de reload. Sin esto, el
// boot que sigue relee el mismo estado corrupto (logout a medias / token roto) y
// se vuelve a colgar → loop infinito. Exportada para test.
export const reloadLimpio = () => {
  purgeSupabaseAuthStorage()
  try { window.location.reload() } catch (_) { /* entorno sin reload */ }
}

export const scheduleBootWatchdog = (ms = BOOT_WATCHDOG_MS) => {
  if (typeof window === 'undefined') return
  window.setTimeout(() => {
    if (!document.getElementById('app-loading-card')) return // el boot ya pintó algo
    const root = document.getElementById('app-root')
    if (!root) return
    hideLoadingOverlay() // el boot se colgó: bajar la foto para que se vea "Reintentar"
    renderBootError(root)
    root.querySelector?.('[data-boot-retry]')?.addEventListener?.('click', reloadLimpio)
  }, ms)
}
